export default "__VITE_ASSET__DWhAv8AY__"